export default __webpack_public_path__ + "9fc54da777f497769a74b2fcc41891a6.svg";